import { apiService } from './api';

export interface LoginActivity {
  id: string;
  email: string;
  userId?: string | null;
  userRole?: string | null;
  portal: string;
  success: boolean;
  failureReason?: string | null;
  ipAddress?: string | null;
  userAgent?: string | null;
  browser?: string | null;
  os?: string | null;
  deviceType?: string | null;
  city?: string | null;
  country?: string | null;
  createdAt: string;
  user?: {
    id: string;
    email: string;
    firstName?: string;
    lastName?: string;
    role?: string;
  } | null;
}

export interface LoginActivityResponse {
  success: boolean;
  data: LoginActivity[];
  pagination: {
    page: number;
    limit: number;
    total: number;
    pages: number;
  };
}

class LoginActivityService {
  async getLoginActivity(params?: {
    page?: number;
    limit?: number;
    email?: string;
    portal?: string;
    success?: boolean;
    search?: string;
    startDate?: string;
    endDate?: string;
  }): Promise<LoginActivityResponse> {
    const queryParams = new URLSearchParams();
    if (params?.page) queryParams.append('page', String(params.page));
    if (params?.limit) queryParams.append('limit', String(params.limit));
    if (params?.email) queryParams.append('email', params.email);
    if (params?.portal) queryParams.append('portal', params.portal);
    if (params?.success !== undefined) queryParams.append('success', String(params.success));
    if (params?.search) queryParams.append('search', params.search);
    if (params?.startDate) queryParams.append('startDate', params.startDate);
    if (params?.endDate) queryParams.append('endDate', params.endDate);

    const qs = queryParams.toString();
    return apiService.get<LoginActivityResponse>(`/login-activity${qs ? `?${qs}` : ''}`);
  }

  formatPortal(portal: string): string {
    const map: Record<string, string> = {
      admin: 'Administrator',
      publisher: 'Publisher',
      client: 'Client',
      agency: 'Agency',
      portal: 'Client / Agency',
      legacy: 'Legacy',
    };
    return map[portal] || portal;
  }

  formatLocation(row: LoginActivity): string {
    const parts = [row.city, row.country].filter(Boolean);
    return parts.length > 0 ? parts.join(', ') : '—';
  }

  formatDevice(row: LoginActivity): string {
    const parts = [row.deviceType, row.os, row.browser].filter(Boolean);
    return parts.length > 0 ? parts.join(' · ') : '—';
  }

  formatUserName(row: LoginActivity): string {
    if (row.user?.firstName && row.user?.lastName) {
      return `${row.user.firstName} ${row.user.lastName}`;
    }
    return row.user?.email || row.email;
  }
}

export const loginActivityService = new LoginActivityService();
